import MainView from './main-view';
import { MondayProvider } from '../../contexts/monday-context';
import { SettingsProvider } from '../../contexts/settings-context';
import { TipseensProvider } from '../../contexts/tipseen-context';
import { OrderProvider } from '../../contexts/order-context';

export default function MainViewWrapper() {
  return (
    <MondayProvider>
      <TipseensProvider>
        <SettingsProvider>
          <OrderProvider>
            <MainView />
          </OrderProvider>
        </SettingsProvider>
      </TipseensProvider>
    </MondayProvider>
  );
}
